import { CommonUtility } from '@utility/common';
import { APIPath } from '../constants/api';
import { BaseService } from './base';

export class CatalogSettings {
  discontinuedItems = reqParams => {
    const params = CommonUtility.objectToParams(reqParams);
    return BaseService.get(`${APIPath.archiveItems}?${params}`);
  };

  updateDiscontinuedItems = data =>
    BaseService.put(`${APIPath.archiveItems}/${data}`);
}

const CatalogSettingsService = new CatalogSettings();
Object.freeze(CatalogSettingsService);
export default CatalogSettingsService;
